
var swiper = new Swiper(".marquee__v2--slider", {
  slidesPerView: 1.2,
  spaceBetween: 15,
  loop: true,
  freeMode: true,
  autoplay: {
    delay: 0,
  },
  speed: 5000,
 
  breakpoints: {
    550: {
      slidesPerView: 2,
      spaceBetween: 15,
     

    },
    768: {
      slidesPerView: 3.3,
      spaceBetween: 25,
      
    },
    972: {
      slidesPerView: 4.2,
      spaceBetween: 25,
      
    },
  },
 

});